import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Switch
} from 'antd';
import React, { useEffect, useState } from 'react';
import InputMask from '../../components/input-mask';
import { prefijos3Digitos, validarCaracterTelefono } from '../../utils';

const { Option } = Select;
const { RangePicker } = DatePicker;

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px'
};
const LaboralesCartaVerdeForm = ({ data, updateData, form }) => {
  const [tipoTrabajo, setTipoTrabajo] = useState();

  useEffect(() => {
    if (data.trabajo) {
      setTipoTrabajo(data.trabajo);
    }
  }, [data, setTipoTrabajo]);

  return (
    <Form
      name="laborales"
      form={form}
      scrollToFirstError
      initialValues={data}
      layout="vertical"
      noValidate
      onValuesChange={(changedValues, allValues) => updateData(allValues)}
    >
      <Row
        gutter={[16, 0]}
        style={{
          // maxWidth,
          margin: 'auto',
          textAlign: 'start'
        }}
      >
        <Col xs={24} md={12}>
          <Form.Item
            label="Profesión / Ocupación"
            name="profesion"
            rules={[{ required: true }]}
          >
            <Input placeholder="Ej.: Comerciante, Abogado/a, Electricista, etc." />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Rango de Ingresos Mensuales Personales (Gs.)"
            name="ingresos"
            rules={[{ required: true }]}
          >
            <Radio.Group>
              <Radio style={radioStyle} value="1">
                1.000.000 a 5.000.000
              </Radio>
              <Radio style={radioStyle} value="2">
                5.000.000 a 10.000.000
              </Radio>
              <Radio style={radioStyle} value="3">
                10.000.000 a 15.000.000
              </Radio>
              <Radio style={radioStyle} value="4">
                Más de 15.000.000
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="¿Es Proveedor del Estado?"
            name="proveedorEstado"
            valuePropName="checked"
          >
            <Switch checked={data.proveedorEstado} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="¿Es una Persona Políticamente Expuesta?"
            name="politicamenteExpuesto"
            valuePropName="checked"
          >
            <Switch checked={data.politicamenteExpuesto} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Tipo de Trabajo"
            name="trabajo"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir trabajo"
              onChange={(value) => setTipoTrabajo(value)}
            >
              <Option value="empleadoPublico">Empleado público</Option>
              <Option value="dependiente">Dependiente</Option>
              <Option value="independiente">Independiente</Option>
              <Option value="jubilado">Jubilado</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            shouldUpdate={(prevValues, curValues) =>
              prevValues.politicamenteExpuesto !==
              curValues.politicamenteExpuesto
            }
          >
            {() =>
              form.getFieldValue('politicamenteExpuesto') && (
                <>
                  <Form.Item
                    label="Cargo / Vínculo"
                    name="vinculo"
                    rules={[
                      {
                        required: true,
                        message: 'Este campo es obligatorio'
                      }
                    ]}
                  >
                    <Input placeholder="Mencione el cargo o vínculo" />
                  </Form.Item>
                  <Form.Item
                    label="Entidad"
                    name="entidad"
                    rules={[
                      {
                        required: true,
                        message: 'Este campo es obligatorio'
                      }
                    ]}
                  >
                    <Input placeholder="Ingrese entidad" />
                  </Form.Item>
                  <Form.Item
                    label="Periodo"
                    name="periodo"
                    rules={[
                      {
                        required: true,
                        message: 'Este campo es obligatorio'
                      }
                    ]}
                  >
                    <RangePicker format="DD/MM/YYYY" />
                  </Form.Item>
                </>
              )
            }
          </Form.Item>
        </Col>
        {tipoTrabajo &&
          tipoTrabajo !== 'independiente' &&
          tipoTrabajo !== 'jubilado' && (
            <Divider>Confirme Datos de la Empresa / Empleador</Divider>
          )}

        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          {tipoTrabajo && (
            <>
              {tipoTrabajo === 'empleadoPublico' && (
                <>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Institución"
                      name="institucion"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Ingrese un valor" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Cargo"
                      name="cargo"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Ingrese un valor" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Año ingreso"
                      name="anioIngreso"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Ingrese un valor" />
                    </Form.Item>
                  </Col>
                </>
              )}
              {tipoTrabajo !== 'independiente' && tipoTrabajo !== 'jubilado' && (
                <>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Razón Social de la Empresa / Empleador"
                      name="empresaEmpleador"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Ingrese un valor" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="RUC de la Empresa / Empleador"
                      name="rucEmpleador"
                      rules={[
                        {
                          pattern: '^[0-9]{5,8}-[0-9]{1}$',
                          message: 'Verificar formato. Ej.: 12345678-9'
                        }
                      ]}
                      validateTrigger="onBlur"
                    >
                      <Input placeholder="Ej.: 12345678-9 - OPCIONAL" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Nro de Teléfono de la Empresa / Empleador"
                      onKeyPress={validarCaracterTelefono}
                      onPaste={validarCaracterTelefono}
                    >
                      <Input.Group compact>
                        <Form.Item
                          name={['telefonoGrupoEmpleador', 'prefijoTelefono']}
                          rules={[
                            {
                              min: 3,
                              message: 'Como mínimo debe contener 3 dígitos'
                            },
                            {
                              max: 4,
                              message: 'Como máximo debe contener 4 dígitos'
                            }
                          ]}
                          noStyle
                        >
                          <Input placeholder="0531" style={{ width: '25%' }} />
                        </Form.Item>
                        <Form.Item
                          name={['telefonoGrupoEmpleador', 'sufijoTelefono']}
                          rules={[
                            {
                              min: 5,
                              message: 'Como mínimo debe contener 5 dígitos'
                            }
                          ]}
                          noStyle
                        >
                          <Input
                            placeholder="000 000"
                            style={{ width: '75%' }}
                          />
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Celular de la Empresa / Empleador"
                      name="celularEmpleador"
                      rules={[
                        {
                          pattern: `^\\((${prefijos3Digitos.join(
                            '|'
                          )})\\) [0-9]{3}-[0-9]{3}$`,
                          message: 'Número no válido'
                        }
                      ]}
                    >
                      <InputMask
                        mask="(999) 999-999"
                        placeholder="(___) ___-___ - OPCIONAL"
                        addonBefore={data.prefix}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Dirección de la Empresa / Empleador"
                      name="direccionEmpleador"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Ingrese un valor" />
                    </Form.Item>
                  </Col>
                </>
              )}
            </>
          )}
        </Row>
      </Row>
    </Form>
  );
};

export default LaboralesCartaVerdeForm;
